import React, { useEffect, useState } from "react";
import { Box, Grid, IconButton, Modal } from "@material-ui/core";
import styles from "./Dialogs.module.scss";
import { ScaleLoader } from "react-spinners";
import NoRecord from "../../assets/noRecord.svg";
import { useTable } from "react-table";
import { mpaDetailColumns } from "../ColumnTemplate";
import { CloseRounded } from "@material-ui/icons";
import axios from "axios";

const TableModal = ({ uniqueKey, open, setOpen, title = "", url }) => {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "83%",
    height: "85%",
    bgcolor: "background.paper",
    boxShadow: 24,
    filter: "drop-shadow(0px 0px 20px rgba(0, 0, 0, 0.15))",
  };

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [columns, setColumns] = useState([]);

  const handleClose = () => setOpen(false);

  const getMainListing = async () => {
    setLoading(true);
    await axios
      .get(url)
      .then((response) => {
        if (response) {
          setData(response.data.response);
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const updateMyData = () => {
    getMainListing();
  };

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({
      columns,
      data,
      updateMyData,
      setLoading,
    });

  useEffect(() => {
    const fetchedColumn = mpaDetailColumns(data);
    setColumns(fetchedColumn);
    updateMyData();
  }, []);

  const table = (
    <div className={`${styles.tableContainer}`}>
      <table {...getTableProps()} className="table">
        <thead className="thead">
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => {
                return (
                  <th {...column.getHeaderProps()} className={"header"}>
                    <span>{column.render("Header")}</span>
                  </th>
                );
              })}
            </tr>
          ))}
        </thead>
        {
          <tbody {...getTableBodyProps()}>
            {rows.map((row, i) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()} className="row">
                  {row.cells.map((cell) => {
                    return (
                      <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        }
      </table>
    </div>
  );

  const loaderBar = (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        height: "inherit",
        alignItems: "center",
      }}
    >
      <ScaleLoader height={20} width={10} color={"#1c4980"} />
    </div>
  );

  return (
    <Modal
      open={open}
      className={styles.tableModal}
      onClose={(event, reason) => {
        if (reason !== "backdropClick") {
          handleClose();
        }
      }}
    >
      <Box sx={style} className={styles.tableBox}>
        <p className={styles.header}>
          {title}
          <IconButton onClick={handleClose}>
            <CloseRounded
              style={{
                color: "#2E2E2E",
                width: "35px",
                height: "35px",
              }}
            />
          </IconButton>
        </p>
        {loading ? (
          loaderBar
        ) : data.length === 0 ? (
          <div className={styles.noRecord}>
            <img src={NoRecord} alt="noRecord" />
            <span>No records found</span>
          </div>
        ) : (
          <Grid item xs={12} className="paddingTop16" style={{ height: "99%" }}>
            {table}
          </Grid>
        )}
      </Box>
    </Modal>
  );
};

export default TableModal;
